import { PERMISSIONS } from "./constants";
import { getInventoryRoutePermissions } from "./module-access";
import { moduleAnyOf } from "./modules";
import type { PermissionCheck } from "./types";

export const ROUTE_PERMISSIONS: Record<string, PermissionCheck> = {
  "/suppliers": { anyOf: moduleAnyOf("supplier") },
  "/suppliers/create-supplier": { permission: PERMISSIONS.SUPPLIER_CREATE },
  "/suppliers/:id/edit": { permission: PERMISSIONS.SUPPLIER_UPDATE },
  "/suppliers/:id": {
    anyOf: [PERMISSIONS.SUPPLIER_VIEW, PERMISSIONS.SUPPLIER_UPDATE],
  },
  "/purchase-orders": { anyOf: moduleAnyOf("po") },
  "/purchase-orders/create-order": { permission: PERMISSIONS.PO_CREATE },
  "/purchase-orders/:id": {
    anyOf: [PERMISSIONS.PO_VIEW, PERMISSIONS.PO_UPDATE],
  },
  "/receiving-qc": { anyOf: moduleAnyOf("po") },
  "/receiving-orders/create/:poId": {
    permission: PERMISSIONS.PO_CREATE,
  },
  "/transfers": { anyOf: moduleAnyOf("transfer") },
  "/transfers/:id": {
    anyOf: [
      PERMISSIONS.TRANSFER_VIEW_INCOMING,
      PERMISSIONS.TRANSFER_VIEW_OUTGOING,
      PERMISSIONS.TRANSFER_UPDATE,
    ],
  },
  "/incoming-transfers": {
    anyOf: [PERMISSIONS.TRANSFER_VIEW_INCOMING],
  },
  "/branch-transfers": { anyOf: moduleAnyOf("transfer") },
  "/transfers/create-transfer": {
    anyOf: [PERMISSIONS.TRANSFER_CREATE, PERMISSIONS.TRANSFER_UPDATE],
  },
  "/branch-transfers/receive-transfer/:id": {
    permission: PERMISSIONS.TRANSFER_CONFIRM,
  },
  "/prepared-item-requests": {
    permission: PERMISSIONS.CK_REQUEST_PREPARED_ITEM_VIEW,
  },
  "/prepared-item-requests/:id": {
    permission: PERMISSIONS.CK_REQUEST_PREPARED_ITEM_VIEW,
  },
  "/prepared-item-requests/aggregated-item-details/:id": {
    permission: PERMISSIONS.CK_REQUEST_PREPARED_ITEM_VIEW,
  },
  "/prepared-item-requests/review-preparation-plan/:id": {
    permission: PERMISSIONS.CK_REQUEST_PREPARED_ITEM_CONFIRM_QTY,
  },
  "/prepared-item-requests/send-items/:id": {
    permission: PERMISSIONS.CK_REQUEST_PREPARED_ITEM_SEND_ITEM,
  },
  "/requests-sent": {
    anyOf: [
      PERMISSIONS.BRANCH_REQUEST_PREPARED_ITEM_VIEW,
      PERMISSIONS.BRANCH_REQUEST_PREPARED_ITEM_UPDATE,
    ],
  },
  "/requests-sent/:id": {
    anyOf: [
      PERMISSIONS.BRANCH_REQUEST_PREPARED_ITEM_VIEW,
      PERMISSIONS.BRANCH_REQUEST_PREPARED_ITEM_UPDATE,
    ],
  },
  "/requests-sent/create": {
    permission: PERMISSIONS.BRANCH_REQUEST_PREPARED_ITEM_CREATE,
  },
  "/requests-sent/:id/edit": {
    permission: PERMISSIONS.BRANCH_REQUEST_PREPARED_ITEM_UPDATE,
  },
  "/items": { anyOf: moduleAnyOf("items") },
  "/items/raw-materials": { anyOf: moduleAnyOf("items") },
  "/items/prepared-items": { anyOf: moduleAnyOf("items") },
  "/items/prepared-items/create": { permission: PERMISSIONS.ITEMS_CREATE },
  "/items/prepared-items/:id/edit": { permission: PERMISSIONS.ITEMS_UPDATE },
  "/items/prepared-items/:id": {
    anyOf: [PERMISSIONS.ITEMS_VIEW, PERMISSIONS.ITEMS_UPDATE, PERMISSIONS.ITEMS_CREATE],
  },
  "/prepared-items/finish-items-setup": {
    anyOf: [PERMISSIONS.ITEMS_CREATE, PERMISSIONS.ITEMS_UPDATE],
  },
  "/items/create-item": { permission: PERMISSIONS.ITEMS_CREATE },
  "/items/:id/edit": { permission: PERMISSIONS.ITEMS_UPDATE },
  "/items/:id": {
    anyOf: [PERMISSIONS.ITEMS_VIEW, PERMISSIONS.ITEMS_UPDATE],
  },
  "/preparation-management": { anyOf: moduleAnyOf("items") },
  "/preparation-management/produce": {
    permission: PERMISSIONS.ITEMS_CREATE,
  },
  "/preparation-management/batch-details/:id": { anyOf: moduleAnyOf("items") },
  "/inventory": { anyOf: getInventoryRoutePermissions() },
  "/inventory/set-opening-balance": {
    permission: PERMISSIONS.OPENING_BALANCE_CREATE,
  },
  "/inventory/:id": {
    permission: PERMISSIONS.INVENTORY_VIEW,
  },
};
